import React, { useState } from "react";
import axiosInstance from "../../../axiosConfig";
import ReactJson from "react-json-view";
import { fetchEsgData } from "../../../network/fetch";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

import State from "../State";

const Step2Form = () => {
  const total_steps = 2; // Par exemple, s'il y a 5 étapes au total
  const current_step = 2; // Étape actuelle

  const reportId = State.reportId;
  const [metadata, setMetadata] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownloadClick = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetchEsgData(reportId || Math.floor(Math.random() * 100000000));
      console.log("=== response === Step2Form.js === key: 421238 ===");
      console.dir(response, { depth: null, colors: true });
      console.log("=================================");
      if (response.success) {
        setMetadata(response.data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des métadonnées:", error);
      setError("Impossible de charger les métadonnées.");
    } finally {
      setLoading(false);
    }
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialStep, setTutorialStep] = useState(0);
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
         <p className="tutorial-title">Téléchargez votre rapport</p>
          <p>
            En tant qu’acteur de la chaîne d'approvisionnement ou responsable de
            la gouvernance d'entreprise chargé de finaliser le reporting ESG,
            vous pouvez désormais consulter les données brutes ESG.
          </p>
          <p>
            Il est possible que la transaction soit encore en cours de
            validation. Cliquez à nouveau sur le bouton pour afficher les
            données dès qu'elles seront disponibles.
          </p>
        </>
      ),
      closeLabel: "hidden",
      position: { top: "70px", left: "50%", transform: "translateX(-50%)" },
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);
  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">Téléchargez votre rapport</p>
          <p>
            En tant qu’acteur de la chaîne d'approvisionnement ou responsable de
            la gouvernance d'entreprise chargé de finaliser le reporting ESG,
            vous pouvez désormais consulter les données brutes ESG.
          </p>
          <p>
            Il est possible que la transaction soit encore en cours de
            validation. Cliquez à nouveau sur le bouton pour afficher les
            données dès qu'elles seront disponibles.
          </p>
        </>
      ),
      closeLabel: "hidden",
      nextLabel: "hidden",

      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  return (
    <form className="container form-esg-2">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>

       {/* Affichage du popup tutoriel */}
       {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={
            tutorialSteps[tutorialStep].handleNextTutorialStep ||
            handleNextTutorialStep
          }
          onClose={handleCloseTutorial}
          showArrow={tutorialSteps[tutorialStep].showArrow === true}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}

      <div className="fiels-main-wrapper">
        <div className="action-btn">
            {!metadata && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleDownloadClick}
          >
            Télécharger le fichier JSON
          </button>)}
            {metadata && (
          <button
            type="button"
            className="btn btn-primary"
            onClick={()=>{
                setMetadata(null);
            }}
          >
            Masquer le fichier JSON
          </button>)}
        </div>
        {loading && (
            <div className="spinner-wrapper" style={{"margin-top":"40px"}}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        {metadata && (
          <div className="metadata-display"style={{"margin-top":"40px","margin-bottom":"-10px"}}>
            <h4>Métadonnées du rapport :</h4>
            <ReactJson
              src={metadata}
              displayRoot={false} // Pour masquer l'objet racine (facultatif)
              theme="monokai" // Vous pouvez changer ce thème selon vos préférences
              collapsed={false} // Pour s'assurer que le JSON est entièrement déployé
              displayDataTypes={false} // Pour masquer les types de données (facultatif)
              displayObjectSize={false} // Pour masquer la taille de l'objet (facultatif)
              enableClipboard={false} // Pour désactiver le bouton de copie (facultatif)
            />
          </div>
        )}
      </div>
    </form>
  );
};

export default Step2Form;
